docReady(function () {
    // Ajax test call 
    // $.ajax({
    //     type: "POST",
    //     url: example_call.ajaxurl,
    //     data: ({ 
    //         action: "example_call", 
    //     }),
    //     success: function(response) {
    //         console.log(response)
    //     },
    // });
    
});
